<template>
  <div class="right-content">
    <a-spin :spinning="loading">
      <template v-if="prescriptions && prescriptions.length">
        <TabSwitch @change="getUniteDetail" v-model="prescriptionValue" :tabs="prescriptions" />
        <div class="body">
          <TheContent title="诊断/证型" class="project">
            <div class="diagnosis-pattern">
              <label class="label">诊断:</label>
              <span class="value">
                <template v-if="data.westernDiagnoses && data.westernDiagnoses.length">
                  {{ data.westernDiagnoses.map(n => n.name).join(',') }}
                </template>
                <template v-else>--</template>
              </span>
            </div>
            <div class="diagnosis-pattern">
              <label class="label">证型:</label>
              <span class="value">
                <template v-if="data.chineseDiagnoses && data.chineseDiagnoses.length">
                  {{ data.chineseDiagnoses.map(n => n.name).join(',') }}
                </template>
                <template v-else>--</template>
              </span>
            </div>
          </TheContent>
          <!-- 处方信息 -->
          <TheContent title="处方信息" class="project">
            <template #tags>
              <!--  0:未购 1:全部购买 2:已下单未支付 -->
              <a-tag v-if="StatusImg?.alt === '已购买'" color="success">已购买</a-tag>
              <a-tag v-else color="warning">{{ StatusImg?.alt }}</a-tag>
            </template>
            <template #titleRight>
              <div class="titleRight">
                <!-- 待购工单AI语音优化-->
                <template v-if="!!data.chatSummaryId">
                  <a-button size="small" class="button" type="link" @click="openSummaryPanel">
                    未购原因
                  </a-button>
                  <a-divider type="vertical" />
                </template>
                <a-button size="small" class="button" type="link" @click="afterSales">
                  发起售后
                </a-button>
                <a-divider type="vertical" />
                <a-button size="small" class="button" type="link" @click="handleLogistics">
                  <img class="button-img" :width="16" :height="16" :src="logistics" alt="物流" />
                  物流详情
                </a-button>
                <a-divider type="vertical" />
                <a-button @click="openDetail" size="small" class="button" type="link">
                  处方详情
                  <RightOutlined class="button-icon" />
                </a-button>
              </div>
            </template>
            <div class="online" v-if="hasDrugs">
              <!-- ===============健康用品================== -->
              <template v-if="healthData && healthData.length">
                <div v-for="item in healthData" :key="item.key" class="content">
                  <div class="top">
                    <span class="left">{{ item.skuName || '--' }}</span>
                    <span class="right">
                      <span class="X">X</span>
                      {{ item.quantity || '--' }}
                    </span>
                  </div>
                </div>
              </template>
              <!-- ===============西药================== -->
              <template v-if="westernData && westernData.length">
                <div v-for="item in westernData" :key="item.key" class="content">
                  <div class="top">
                    <span class="left">{{ item.skuName || '--' }}</span>
                    <span class="right">
                      <span class="X">X</span>
                      {{ item.quantity || '--' }}
                    </span>
                  </div>
                  <!-- 健康用品不展示 -->
                  <div class="bottom">用法：{{ item.usageStr || '--' }}</div>
                </div>
              </template>
              <!-- ===============协定方=============== -->
              <template v-if="protocolData && protocolData.length">
                <div v-for="item in protocolData" :key="item.key" class="content">
                  <div class="top">
                    <span class="left">{{ item.skuName || '--' }}</span>
                    <span class="right">
                      <span class="X">X</span>
                      {{ item.quantity || '--' }}
                    </span>
                  </div>
                  <!-- 健康用品不展示 -->
                  <div class="bottom" v-if="item.prescriptionType !== 3">
                    用法：{{ item.usageStr || '--' }}
                  </div>
                </div>
              </template>
              <!-- ===============中药=============== -->
              <template v-if="chineseData && chineseData.length">
                <div v-for="item in chineseData" :key="item.key" class="content chineseData">
                  <div class="top">
                    <span class="left">{{ item.chineseName || '--' }}</span>
                  </div>
                  <!-- 健康用品不展示 -->
                  <div class="bottom">用法：{{ item.usageStr || '--' }}</div>
                </div>
              </template>
            </div>
            <EmptyText v-else />
          </TheContent>
          <TheContent title="费用结算" class="project">
            <div class="cost-table">
              <div class="table_top">
                <div class="table_item">诊疗费</div>
                <div class="table_item">医药费</div>
                <div class="table_item">总计</div>
              </div>
              <div class="table_bottom">
                <div class="table_item">
                  <template v-if="data.cureServiceAmount">¥ {{ data.cureServiceAmount }}</template>
                  <template v-else>--</template>
                </div>
                <div class="table_item">
                  <template v-if="data.medicineAmount">¥ {{ data.medicineAmount }}</template>
                  <template v-else>--</template>
                </div>
                <div class="table_item">
                  <template v-if="data.summationAmount">¥ {{ data.summationAmount }}</template>
                  <template v-else>--</template>
                </div>
              </div>
            </div>
          </TheContent>
          <!-- 通用 -->
          <TheContent :showDivider="false" title="复诊预约" class="project">
            <div class="Followup-Appointment">
              <div v-if="[1, 2].includes(data.revisitInfoVO?.revisitType)" class="Followup-item">
                <div class="left-text">
                  <span>{{ `${data.revisitInfoVO.revisitTime}` }}｜</span>
                  <span>{{ `${treatWay[data.revisitInfoVO?.revisitType]}` }}</span>
                </div>
                <div @click="openRevisit" class="right-text">
                  {{ config.RESERCE_STATE_MAP[data.revisitInfoVO?.reserveState] }}
                  <RightOutlined />
                </div>
              </div>
              <div v-else class="Followup-item">遵医嘱复诊</div>
            </div>
            <!-- <EmptyText v-else /> -->
          </TheContent>
        </div>
      </template>
      <EmptyText class="Empty" v-else />
    </a-spin>
    <!-- 处方详情 -->
    <the-detail
      v-model:visible="detail.visible"
      :id="detail.id"
      :serialNumber="detail.serialNumber"
      :recordType="detail.recordType"
    />
    <!-- 复诊预约详情 -->
    <ADetail ref="aDetail" :recordId="appointId" />
    <!-- 物流详情 -->
    <Logistics ref="LogisticsRef" :prescriptionSn="prescriptionValue" />
    <a-modal
      title="沟通小结"
      :visible="summaryPanelVisible"
      @cancel="summaryPanelVisible = false"
      width="1059px"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :bodyStyle="{
        padding: 0,
        paddingTop: '20px'
      }"
      :scroll="{ y: 300 }"
    >
      <SummaryPannel
        :chatSummaryId="chatSummaryId"
        @closeSummaryModal="summaryPanelVisible.value = false"
        :active="0"
      />
    </a-modal>
  </div>
</template>

<script setup>
import ADetail from '@/views/WorkPlace/components/Appoint/index.vue'
import TheDetail from '@/components/TheDetail/index.vue'
import logistics from '@/assets/img/PatientFile/logistics.png'
import TheContent from './components/TheContent.vue'
import { computed, nextTick, ref, watch } from 'vue'
import { RightOutlined } from '@ant-design/icons-vue'
import { uniteDetail } from '@/api/workPlace/prescription'
import { useStore } from 'vuex'
import { getPrescriptionListByConsult } from '@/api/patientFile'
import config from '@/config/index'
import Logistics from '@/components/Logistics'
import { getStatusLabel } from '@/utils'
import EmptyText from '@/components/PatientFile/EmptyText.vue'
import { message } from 'ant-design-vue'
import { SummaryPannel } from '@/views/WorkPlace/Container/chat/components'
import TabSwitch from '../../../components/TabSwitch.vue'

const StatusImg = computed(() => {
  const params = {
    status: data.value.status,
    expire: data.value.expireStatus,
    invalid: data.value.invalid
  }
  const ans = getStatusLabel(params) || {}
  return ans
})

const store = useStore()
const doctorInfo = computed(() => store.state.patientFile.bindUser.doctorInfo)
const info = computed(() => store.state.patientFile.info)
// 当前点击的某一次问诊
const diagnosisPattern = computed(() => store.state.patientFile.diagnosisPattern)
const summaryPanelVisible = ref(false)
const chatSummaryId = ref()

const prescriptions = ref([])
const treatWay = {
  1: '线上问诊',
  2: '门诊就诊'
}
const prescriptionValue = ref(null)
const loading = ref(false)
const data = ref({})
const LogisticsRef = ref(null)
const detail = ref({
  visible: false,
  id: '0',
  serialNumber: '',
  recordType: 'prescriptionGroup'
})
const appointId = ref('')
const aDetail = ref()
// 打开处方详情
function openDetail() {
  detail.value.serialNumber = data.value.serialNumber
  detail.value.visible = true
}
// 打复诊预约
function openRevisit() {
  appointId.value = data.value.revisitInfoVO.reserveId
  nextTick(() => {
    aDetail.value.mVisible = true
    aDetail.value.initDetail()
  })
}
// 处理数据
const chineseData = ref([])
const healthData = ref([])
const westernData = ref([])
const protocolData = ref([])
// 判断是否有药品数据
const hasDrugs = computed(() => {
  const hasChinese = !!(chineseData.value && chineseData.value.length)
  const hasWestern = !!(westernData.value && westernData.value.length)
  const hasProtocol = !!(protocolData.value && protocolData.value.length)
  const hasHealthData = !!(healthData.value && healthData.value.length)
  return hasChinese || hasWestern || hasProtocol || hasHealthData
})
function detailDrugsData() {
  // 清空
  chineseData.value = []
  healthData.value = []
  westernData.value = []
  protocolData.value = []
  // healthPrescriptionDetailVO 健康辅助方子
  // prescriptionDetailVOList 中 prescriptionType
  // 0 联合处方
  // 1 西药
  // 2 中药
  // 21协定方 废弃
  // 3健康辅助方
  // prescriptionBusinessType 1 就是协定方
  const { prescriptionDetailVOList = [], healthPrescriptionDetailVO = {} } = data.value
  // 健康用品的数据
  healthData.value = healthPrescriptionDetailVO?.medicineDetailVOList?.map(val => {
    return {
      ...val,
      ...healthPrescriptionDetailVO
    }
  })
  // 西药
  const _westernData = prescriptionDetailVOList.filter(n => n.prescriptionType === 1) || []
  _westernData.forEach(element => {
    westernData.value = westernData.value.concat(element.medicineDetailVOList)
  })
  // 协定方
  const _protocolData = prescriptionDetailVOList.filter(n => n.prescriptionBusinessType === 1) || []
  _protocolData.forEach(element => {
    protocolData.value = protocolData.value.concat(element.medicineDetailVOList)
  })
  // 中药的数据
  const _chineseData =
    prescriptionDetailVOList.filter(
      n => n.prescriptionType === 2 && n.prescriptionBusinessType !== 1
    ) || []
  _chineseData.forEach(element => {
    let chineseName = ''
    const len = element?.medicineDetailVOList?.length || 0
    element.medicineDetailVOList.forEach((element, i) => {
      // 最后一个没有逗号
      if (i === len - 1) {
        chineseName += `${element.skuName} (${element.quantity}g)`
      } else {
        chineseName += `${element.skuName} (${element.quantity}g),`
      }
    })
    element.chineseName = chineseName
    chineseData.value.push(element)
  })
}
const afterSales = () => {
  const parentOrderSn = data.value.combineOrderSn
  // console.log(`output->data `, data)
  if (parentOrderSn) {
    const url =
      process.env.VUE_APP_CMS_URL + `/orderv1Manage/salesOrder?parentOrderSn=${parentOrderSn}`
    window.open(url)
  } else {
    message.warn('父订单id不存在')
  }
}

const handleLogistics = () => {
  LogisticsRef.value.visible = true
}
// 获取详情
function getUniteDetail() {
  const id = prescriptionValue.value
  data.value = {}
  if (!id) return
  loading.value = true
  uniteDetail(id)
    .then(result => {
      data.value = result
      detailDrugsData()
    })
    .finally(() => {
      loading.value = false
    })
}
// 待购工单AI语音优化打开小结
function openSummaryPanel() {
  summaryPanelVisible.value = true
  chatSummaryId.value = data.value.chatSummaryId
}

watch(
  () => diagnosisPattern.value.businessId,
  businessId => {
    if (!businessId) return
    // 线上存在多个处方
    const params = {
      consultId: businessId,
      ucDoctorId: doctorInfo.value.ucDoctorId,
      ucPatientId: info.value.ucPatientId
    }
    getPrescriptionListByConsult(params).then((result = []) => {
      prescriptions.value = result.map((val, index) => ({ label: `处方${++index}`, value: val }))
      // 默认第一个
      prescriptionValue.value = result[0]
      getUniteDetail()
    })
  },
  {
    immediate: true
  }
)
</script>

<style lang="scss" scoped>
.right-content {
  ::v-deep(.ant-spin-nested-loading) {
    height: 100%;
    .ant-spin-container {
      height: 100%;
    }
  }
  .prescription {
    margin-bottom: 12px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    .header_title {
      font-size: 14px;
      color: #999999;
      font-weight: 400;
    }
  }
  .body {
    .project {
      &:last-child {
        margin-bottom: 0;
      }
      .cursor {
        cursor: pointer;
      }
      .titleRight {
        display: flex;
        align-items: center;
        .button {
          color: #014ea8;
          display: inline-flex;
          align-items: center;
          .button-img {
            margin-right: 8px;
          }
          .button-icon {
            font-size: 12px;
            margin-left: 2px;
          }
        }
      }
      .diagnosis-pattern {
        .label {
          color: #999999;
          font-size: 14px;
          font-weight: 500;
          margin-right: 8px;
        }
        .value {
          color: #333333;
          font-size: 14px;
          font-weight: 500;
        }
      }
      .online {
        display: grid;
        grid-gap: 10px;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        // grid-template-columns: 50% 50%;
        .content {
          border-radius: 8px;
          background: #fafafa;
          padding: 12px 10px;
          .top {
            display: flex;
            justify-content: space-between;
            .left {
              font-weight: 400;
              font-size: 16px;
              color: #333333;
              flex-grow: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .right {
              flex-shrink: 0;
              font-weight: 400;
              font-size: 16px;
              color: #666666;
              width: 40px;
              text-align: right;
              font-size: 16px;
              .X {
                font-size: 14px;
              }
            }
          }
          .bottom {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #666666;
          }
        }
        .chineseData {
          grid-column: span 2;
        }
      }
      .cost-table {
        border: 1px solid #e3e3e3;
        border-radius: 4px;
        overflow: hidden;
        .table_top,
        .table_bottom {
          display: flex;
          .table_item {
            padding: 10px 15px;
            width: 33.33333%;
            border-right: 1px solid #e3e3e3;
            &:last-child {
              border-right: none;
            }
          }
        }
        .table_top {
          font-size: 14px;
          color: #666666;
          background: #fafafa;
          border-bottom: 1px solid #e3e3e3;
        }
      }
      .Followup-Appointment {
        .Followup-item {
          width: 50%;
          background: #fafafa;
          border-radius: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 12px;
          font-weight: 500;
          font-size: 16px;
          color: #1b1b1b;
          margin: 0 10px 10px 0;
          .right-text {
            cursor: pointer;
            font-weight: 400;
            font-size: 16px;
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
